import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { EGetFavoritesListActionTypes, TGetFavoritesListFailed } from './types';

export const getFavoritesListFailure: () => TGetFavoritesListFailed =
  actionGenerator<EGetFavoritesListActionTypes.Failed>(EGetFavoritesListActionTypes.Failed);
